<template>
  <div class="row">
    <br />
    <br />

    <select class="browser-default" v-model="level">
      <option value disabled selected>Select Level</option>
      <option
        v-for="level in $store.getters.getInfo"
        :key="level.level"
        :value="level.level"
      >
        Level {{ level.level }}
      </option>
    </select>

    <br />
    <br />

    <div v-if="data.length" style="overflow-x: auto">
      <table class="responsive-table highlight">
        <thead>
          <tr>
            <th>Name</th>
            <th v-for="lesson in lessons" :key="lesson.lesson">{{ lesson.name }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="student in data" :key="student.id" v-show="student.studies.length">
            <td>{{ student.name }}</td>

            <td  v-for="lesson in lessons" :key="lesson.lesson">
              <span v-for="(studie, index) in student.studies" :key="index">
                <span v-if="studie.lesson == lesson.lesson">{{ studie.howLong }}</span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <br />
    <br />
    <br />
  </div>
</template>

<script>
export default {
  data() {
    return {
      level: "",
      students: [],
      studies: [],
      data: [],
    };
  },
  created() {
    this.$store
      .dispatch("getUsers", "student")
      .then((response) => (this.students = response.data));

    this.$store
      .dispatch("getAllStudies")
      .then((response) => (this.studies = response.data));
  },
  computed: {
    lessons() {
      return this.$store.getters.getInfo[this.level - 1]
        ? this.$store.getters.getInfo[this.level - 1].lessons
        : 0;
    },
  },
  watch: {
    level() {
      const data = [];

      this.students.map((student) => {
        this.studies.map((studie) => {
          if (studie.student == student._id) {
            const studieData = [];
            studie.details.map((i) => {
              if (i.level == this.level) {
                studieData.push(i);
              }
            });

            data.push({ name: student.fullName, studies: studieData });
          }
        });
      });

      this.data = data;
    },
  },
};
</script>



<!-- <template>
  <div class="row">
    <br />
    <br />

    <select class="browser-default" v-model="level">
      <option value disabled selected>Select Level</option>
      <option
        v-for="level in $store.getters.getInfo"
        :key="level.level"
        :value="level.level"
      >Level {{ level.level }}</option>
    </select>

    <br />
    <br />

    <div v-if="data.length" style="overflow-x: auto">
      <table class="responsive-table">
        <thead>
          <tr>
            <th>Full&nbsp;Name</th>
            <th v-for="lesson in lessons" :key="lesson.lesson">{{ lesson.name }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(student, studentIndex) in data" :key="student.student">
            <td>{{ student.student }}</td>
            <td
              v-for="(lesson, index) in lessons"
              :key="lesson + index"
            >{{ data[studentIndex].studies[index] ? data[studentIndex].studies[index].howLong : "00:00:00" }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <br />
    <br />
    <br />
  </div>
</template>


<script>
export default {
  data() {
    return {
      level: "",
      students: [],
      studies: [],
      data: []
    };
  },
  created() {
    this.$store
      .dispatch("getUsers", "student")
      .then(response => (this.students = response.data));

    this.$store
      .dispatch("getAllStudies")
      .then(response => (this.studies = response.data));
  },
  computed: {
    lessons() {
      return this.$store.getters.getInfo[this.level - 1]
        ? this.$store.getters.getInfo[this.level - 1].lessons
        : 0;
    }
  },
  watch: {
    level() {
      this.data = [];

      for (let i in this.students) {
        let x = {
          student: this.students[i].fullName,
          studies: []
        };

        if (this.studies[i]) {
          for (let y in this.studies[i].details) {
            if (this.studies[i].details[y].level == this.level) {
              x.studies.push(this.studies[i].details[y]);
            }
          }
        }

        if (x.studies.length) this.data.push(x);
      }

      for (let i in this.data) {
        let z = [];
        let max = 0;

        for (let y in this.data[i].studies) {
          if (this.data[i].studies[y].lesson !== +y + 1) {
            z.push({
              currentIndex: y,
              index: this.data[i].studies[y].lesson,
              lesson: this.data[i].studies[y]
            });
          }
          if (max < this.data[i].studies[y].lesson)
            max = this.data[i].studies[y].lesson;
        }

        if (this.lessons.length !== this.data[i].studies.length) {
          for (let y = 0; y < max - this.data[i].studies.length; y++) {
            this.data[i].studies.push({ howLong: "00:00:00" });
          }
          max = false;
        }

        if (max === false) {
          for (let y = 0; y < z.length; y++) {
            this.data[i].studies[z[y].index - 1] = z[y].lesson;
            this.data[i].studies[z[y].currentIndex] = { howLong: "00:00:00" };
          }
        } else {
          for (let y = 0; y < z.length; y++) {
            this.data[i].studies[z[y].index - 1] = z[y].lesson;
          }
        }
      }
    }
  }
};
</script> 
-->


// WEBPACK FOOTER //
// src/views/Studies.vue